import _jsx from '@babel/runtime/helpers/jsx';
import { useEffect, useRef, useCallback } from 'react';
import { Button } from '@andes/button';
import { c as createDropdownSelector, D as DROPDOWN_CONTAINER_PROP_TYPES, a as DROPDOWN_CONTAINER_DEFAULT_PROPS, b as DROPDOWN_COMPONENT_DEFAULT_PROPS, u as useValueReset, f as useChangeDetection, d as useHighlightTerm, H as HighlightedText, e as useFacetedSearch, F as FacetedSearchDefaultProps } from './use-highlight-term-f0c57bfb.js';
import { d as deserializeState } from './helpers-4945f22e.js';
import { Dropdown as Dropdown$1, DropdownItem } from '@andes/dropdown';
import classnames from 'classnames';
import { TextField } from '@andes/textfield';
import { Popper } from '@andes/popper';
import { List, ListItem } from '@andes/list';
import { Card } from '@andes/card';
import SearchIcon from '@andes/icons/Search20';
import { jsx } from 'react/jsx-runtime';
import 'prop-types';
import '@babel/runtime/helpers/objectSpread2';
import '@andes/switch';
import '@babel/runtime/helpers/objectWithoutProperties';
import 'frontend-restclient';
const SELECTOR_MAX_HEIGHT = 390;
const namespace$2 = "faceted-search-desktop-dropdown";
const filterComparison = () => true;
const InnerDropdown = _ref => {
  let {
    availableOptions,
    searchTerm,
    setSearchTerm,
    value,
    setValue,
    placeholderLabel,
    withSearchBox,
    disabled,
    disableIfEmpty,
    size
  } = _ref;
  useValueReset({
    availableOptions,
    value,
    setValue,
    disabled
  });
  const shouldDisable = disableIfEmpty && searchTerm.trim() === "" && availableOptions.length === 0;
  return /*#__PURE__*/_jsx(Dropdown$1, {
    type: "form",
    size: "small",
    menuAlignment: "bottom",
    menuMaxHeight: SELECTOR_MAX_HEIGHT,
    className: classnames(namespace$2, {
      ["".concat(namespace$2, "--").concat(size)]: size
    }),
    srLabel: placeholderLabel,
    placeholder: placeholderLabel,
    disabled: disabled || shouldDisable,
    value: value,
    onChange: (e, newValue) => {
      if (newValue) {
        setValue(newValue);
        setSearchTerm('');
      }
    },
    search: withSearchBox,
    onSearchChange: setSearchTerm,
    filterCondition: filterComparison
  }, void 0, availableOptions.map(_ref2 => {
    let {
      id: itemId,
      label
    } = _ref2;
    return /*#__PURE__*/_jsx(DropdownItem, {
      className: "".concat(namespace$2, "__item"),
      title: label,
      value: itemId,
      "aria-label": "dropdown-item"
    }, itemId);
  }));
};
InnerDropdown.defaultProps = DROPDOWN_COMPONENT_DEFAULT_PROPS;
const InnerDropdownContainer = createDropdownSelector(InnerDropdown);
InnerDropdownContainer.propTypes = DROPDOWN_CONTAINER_PROP_TYPES;
InnerDropdownContainer.defaultProps = DROPDOWN_CONTAINER_DEFAULT_PROPS;
var Dropdown = InnerDropdownContainer;
const ARROW_UP = 'ArrowUp';
const ARROW_DOWN = 'ArrowDown';
const ESCAPE = 'Escape';
var _span;
const namespace$1 = "faceted-search-desktop-searchbox";
const BaseSearchbox = _ref => {
  let {
    id,
    placeholderLabel,
    disabled,
    disableIfEmpty,
    showSuggester,
    setShowSuggester,
    availableOptions,
    searchTerm,
    setSearchTerm,
    size,
    setValue,
    searchState
  } = _ref;
  const {
    changed
  } = useChangeDetection(searchState, searchState);
  useEffect(() => {
    setShowSuggester(false);
  }, []);
  useEffect(() => {
    setShowSuggester(true);
  }, [availableOptions]);
  useEffect(() => {
    if (changed && searchState !== null && searchState !== void 0 && searchState.label) {
      setSearchTerm(searchState.label, false);
      setShowSuggester(false);
    }
  }, [changed]);
  const highlightTerm = useHighlightTerm(searchTerm, availableOptions);
  const itemRef = useRef(null);
  const hasAvailableOptions = availableOptions.length > 0;
  const isOpen = hasAvailableOptions && showSuggester;
  const onOptionClick = (_, newValue) => {
    const selectedOption = availableOptions.find(opt => opt.id === newValue);
    setValue(newValue);
    setSearchTerm(selectedOption.label, false);
    setShowSuggester(false);
  };
  const handleEscapeKeypress = event => {
    event.preventDefault();
    event.target.blur();
    setShowSuggester(false);
  };
  const onSearchKeyDown = event => {
    const {
      key
    } = event;
    switch (key) {
      case ARROW_UP:
      case ARROW_DOWN:
        event.preventDefault();
        const list = itemRef.current.querySelector("#".concat(id, "-list"));
        const [option] = list.children;
        option === null || option === void 0 || option.focus();
        break;
      case 'esc':
      case ESCAPE:
        handleEscapeKeypress(event);
        break;
    }
  };
  const onItemKeyDown = event => {
    const {
      key
    } = event;
    switch (key) {
      case ARROW_UP:
        event.preventDefault();
        const prevOption = event.target.previousSibling;
        prevOption === null || prevOption === void 0 || prevOption.focus();
        break;
      case ARROW_DOWN:
        event.preventDefault();
        const nextOption = event.target.nextSibling;
        nextOption === null || nextOption === void 0 || nextOption.focus();
        break;
      case 'esc':
      case ESCAPE:
        handleEscapeKeypress(event);
        break;
    }
  };
  return /*#__PURE__*/jsx("div", {
    ref: itemRef,
    className: classnames(namespace$1, {
      ["".concat(namespace$1, "--").concat(size)]: size
    }),
    children: /*#__PURE__*/_jsx(Popper, {
      id: id,
      visible: isOpen,
      interactive: true,
      placement: "bottom",
      className: classnames("".concat(namespace$1, "__floating-menu"), {
        ["".concat(namespace$1, "--").concat(size)]: size
      }),
      onClickOutside: () => setShowSuggester(false),
      content: /*#__PURE__*/_jsx(Card, {
        className: classnames("".concat(namespace$1, "__list-container"), {
          ["".concat(namespace$1, "--").concat(size)]: size
        }),
        shadow: "elevated"
      }, void 0, /*#__PURE__*/_jsx(List, {
        srLabel: "List",
        className: "".concat(namespace$1, "__list"),
        id: "".concat(id, "-list"),
        role: "listbox"
      }, void 0, availableOptions.map(_ref2 => {
        let {
          id: optionId,
          label
        } = _ref2;
        return /*#__PURE__*/_jsx(ListItem, {
          title: "",
          className: "".concat(namespace$1, "__list-item"),
          role: "option",
          onClick: event => onOptionClick(event, optionId),
          "aria-label": label,
          tabIndex: "0",
          onKeyDown: onItemKeyDown
        }, "".concat(label, "-").concat(optionId), /*#__PURE__*/_jsx(HighlightedText, {
          text: label,
          highlightTerm: highlightTerm
        }));
      })))
    }, void 0, /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(TextField, {
      autoComplete: "off",
      autoCorrect: "off",
      autoCapitalize: "off",
      className: "".concat(namespace$1, "__textfield"),
      placeholder: placeholderLabel,
      defaultValue: searchTerm,
      value: searchTerm,
      onChange: event => setSearchTerm(event.target.value),
      onKeyDown: isOpen ? onSearchKeyDown : undefined,
      disabled: disabled || disableIfEmpty,
      srLabel: "textfield"
    }, void 0, _span || (_span = /*#__PURE__*/_jsx("span", {
      className: "".concat(namespace$1, "__icon")
    }, void 0, /*#__PURE__*/_jsx(SearchIcon, {}))))))
  });
};
BaseSearchbox.defaultProps = DROPDOWN_COMPONENT_DEFAULT_PROPS;
const Searchbox = createDropdownSelector(BaseSearchbox);
Searchbox.propTypes = DROPDOWN_CONTAINER_PROP_TYPES;
Searchbox.defaultProps = DROPDOWN_CONTAINER_DEFAULT_PROPS;
const namespace = 'faceted-search-desktop';
const getActionHandler = actionCallback => (event, currentState) => {
  if (actionCallback && typeof actionCallback === 'function') {
    actionCallback(event, deserializeState(currentState));
  }
};
const FacetedSearch = _ref => {
  let {
    renderConfig,
    // eslint-disable-line react/prop-types
    callToAction,
    // eslint-disable-line react/prop-types
    secondaryAction,
    // eslint-disable-line react/prop-types
    onChange,
    // eslint-disable-line react/prop-types
    onAction,
    // eslint-disable-line react/prop-types
    headers,
    // eslint-disable-line react/prop-types
    initialState,
    // eslint-disable-line react/prop-types
    children
  } = _ref;
  const onActionCallback = useCallback((event, currentState) => getActionHandler(onAction)(event, currentState), [onAction]);
  const {
    onAction: onSecondaryAction
  } = secondaryAction || {};
  const onSecondaryActionCallback = useCallback((event, currentState) => getActionHandler(onSecondaryAction)(event, currentState), [onSecondaryAction]);
  const [elements, state] = useFacetedSearch({
    renderConfig,
    onChange,
    headers,
    initialState,
    components: {
      Dropdown,
      Searchbox
    }
  });
  return /*#__PURE__*/_jsx("div", {
    className: namespace
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "__main-container")
  }, void 0, elements.map((elem, index) => /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  _jsx("div", {
    className: "".concat(namespace, "__elem")
  }, index, elem)), (callToAction || secondaryAction) && /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "__elem")
  }, void 0, callToAction && /*#__PURE__*/_jsx(Button, {
    className: "".concat(namespace, "__elem-actions"),
    onClick: evt => onActionCallback(evt, state),
    role: "button"
  }, void 0, callToAction), secondaryAction && /*#__PURE__*/_jsx(Button, {
    className: "".concat(namespace, "__elem-actions"),
    onClick: evt => onSecondaryActionCallback(evt, state),
    hierarchy: "quiet",
    role: "button"
  }, void 0, secondaryAction.label))), children && /*#__PURE__*/_jsx("div", {}, void 0, children));
};
FacetedSearch.defaultProps = FacetedSearchDefaultProps;
export { FacetedSearch as default };
